const textSizeTokens = {
    "text.size.large": 18,
    "text.size.regular": 15,
    "text.size.small": 13,
    "text.size.tiny": 12,
    "text.size.xLarge": 26,
    "text.size.xxLarge": 31
  },
  headerSizeTokens = {
    "header.size.large": 26,
    "header.size.regular": 22
  },
  headerLineHeightTokens = {
    "header.lineHeight.large": 36,
    "header.lineHeight.regular": 30
  },
  textLineHeightTokens = {
    "text.lineHeight.large": 26,
    "text.lineHeight.regular": 22,
    "text.lineHeight.small": 20,
    "text.lineHeight.tiny": 16,
    "text.lineHeight.xLarge": 36,
    "text.lineHeight.xxLarge": 42
  },
  linkSpaceTokens = {
    "link.focusRing.borderWidth": 1.5,
    "link.icon.spacing": 4
  },
  linkRadiusTokens = {
    "link.focusRing.radius": 6
  };
export { headerLineHeightTokens, headerSizeTokens, linkRadiusTokens, linkSpaceTokens, textLineHeightTokens, textSizeTokens };
//# sourceMappingURL=Typography.tokens.mjs.map
